export const discussionsAlgoliaAppId = process.env.NEXT_PUBLIC_ALGOLIA_APP_ID!
export const discussionsAlgoliaApiKey = process.env.NEXT_PUBLIC_DISCUSSIONS_ALGOLIA_API_KEY!
export const discussionsAlgoliaIndex = process.env.NEXT_PUBLIC_DISCUSSIONS_ALGOLIA_INDEX!
export const discussionsAlgoliaIndexNewest = `${discussionsAlgoliaIndex}_newest`
export const discussionsAlgoliaIndexOldest = `${discussionsAlgoliaIndex}_oldest`
export const discussionsAlgoliaIndexPopularity = `${discussionsAlgoliaIndex}_popularity`

export const SORTING_OPTIONS = [
  { value: discussionsAlgoliaIndex, label: 'Recent activity', type: 'recent' },
  { value: discussionsAlgoliaIndexNewest, label: 'Newest discussions first', type: 'newest' },
  {
    value: discussionsAlgoliaIndexPopularity,
    label: 'Most popular',
    type: 'popularity',
  },
  { value: discussionsAlgoliaIndexOldest, label: 'Oldest discussions first', type: 'oldest' },
]
